import React, { useState } from "react";
import { getMiqaatsForDate } from "./getHijriDate";

/**
 * Renders a crescent icon (☽) with a CSS hover tooltip for dates that have Hijri miqaats.
 * Click copies all miqaat names to clipboard.
 *
 * @param {Object} props
 * @param {Date} props.date - Gregorian date to look up
 */
function MiqaatBadge({ date }) {
  const [copied, setCopied] = useState(false);

  if (!date) return null;
  const miqaats = getMiqaatsForDate(date);
  if (!miqaats || miqaats.length === 0) return null;

  const handleClick = (e) => {
    e.stopPropagation();
    const text = miqaats.map((m) => m.title).join(", ");
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  return (
    <span className="miqaat-badge-wrapper">
      <span className="miqaat-badge-icon" onClick={handleClick}>☽</span>
      <span className="miqaat-badge-tooltip-text">
        {copied ? (
          <span className="miqaat-badge-copied">Copied!</span>
        ) : (
          miqaats.map((m, i) => (
            <span key={i} className="miqaat-badge-tooltip-item">{m.title}</span>
          ))
        )}
      </span>
    </span>
  );
}

export default MiqaatBadge;
